import { render } from "./Calculation.vue?vue&type=template&id=a597aa80&scoped=true"
import script from "./Calculation.vue?vue&type=script&lang=js"
export * from "./Calculation.vue?vue&type=script&lang=js"

import "./Calculation.vue?vue&type=style&index=0&id=a597aa80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a597aa80"

export default script